import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { useEffect, useState } from "react";
export var useFetchData = function useFetchData(urlProp) {
  var cacheKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "__cache__";

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isLoaded = _useState2[0],
      setIsLoaded = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isLoading = _useState4[0],
      setIsLoading = _useState4[1];

  var _useState5 = useState(),
      _useState6 = _slicedToArray(_useState5, 2),
      error = _useState6[0],
      setError = _useState6[1];

  var _useState7 = useState(),
      _useState8 = _slicedToArray(_useState7, 2),
      data = _useState8[0],
      setData = _useState8[1];

  var _useState9 = useState(),
      _useState10 = _slicedToArray(_useState9, 2),
      lastLoadedUrl = _useState10[0],
      setLastLoadedUrl = _useState10[1];

  var url = urlProp instanceof URL ? urlProp.href : urlProp;
  var needsLoading = lastLoadedUrl !== url;

  var _useState11 = useState(cacheKey),
      _useState12 = _slicedToArray(_useState11, 2),
      lastCacheKey = _useState12[0],
      setLastCacheKey = _useState12[1];

  useEffect(function () {
    if (lastCacheKey === cacheKey) return;
    console.log({
      lastCacheKey: lastCacheKey,
      cacheKey: cacheKey
    });
    setLastCacheKey(cacheKey);
    setIsLoading(false);
    setIsLoaded(false);
    setData(undefined);
    setLastLoadedUrl(undefined);
  }, [lastCacheKey, cacheKey]);
  useEffect(function () {
    if (!needsLoading && (isLoaded || error)) return;
    if (isLoading) return;

    if (!url) {
      return;
    }

    console.log({
      isLoaded: isLoaded,
      isLoading: isLoading,
      error: error,
      url: url,
      needsLoading: needsLoading
    });
    setIsLoading(true);
    fetch(url, {
      method: "GET",
      credentials: "include",
      mode: "cors"
    }).then( /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(response) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(response.status >= 400)) {
                  _context2.next = 6;
                  break;
                }

                _context2.t0 = Promise;
                _context2.next = 4;
                return response.json();

              case 4:
                _context2.t1 = _context2.sent;
                return _context2.abrupt("return", _context2.t0.reject.call(_context2.t0, _context2.t1));

              case 6:
                setTimeout( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                  return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.t0 = setData;
                          _context.next = 3;
                          return response.json();

                        case 3:
                          _context.t1 = _context.sent;
                          (0, _context.t0)(_context.t1);
                          setIsLoaded(true);
                          setIsLoading(false);

                        case 7:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                })), 10);

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }())["catch"](function (err) {
      var _err$message;

      setError((_err$message = err === null || err === void 0 ? void 0 : err.message) !== null && _err$message !== void 0 ? _err$message : String(err));
      setIsLoading(false);
    })["finally"](function () {
      setLastLoadedUrl(url);
    });
  }, [isLoaded, isLoading, error, url, needsLoading]);
  return {
    isLoaded: isLoaded,
    isLoading: isLoading,
    error: error,
    data: data,
    isEmpty: isLoaded && !error && !data
  };
};